export const i18nContentHash = 'b619367'
